import {naturalSortByKey} from '@benchling/js-utils';
import {useState} from 'react';

import {NOT_ARCHIVED_PURPOSE_STRING} from 'archive/ArchiveConstants';
import strUtil from 'util/strUtil';

import {LibraryParameterDefinition} from '../ParameterLibraryTypes';

export interface FilteredParameterDefinitionsResult {
  filteredParameterDefinitions: Array<LibraryParameterDefinition>;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedArchivePurposes: Array<string>;
  selectArchivePurposes: (purposes: Array<string>) => void;
}

export function useFilteredParameterDefinitions(
  parameterDefinitions: Array<LibraryParameterDefinition>
): FilteredParameterDefinitionsResult {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedArchivePurposes, selectArchivePurposes] = useState<Array<string>>([
    NOT_ARCHIVED_PURPOSE_STRING,
  ]);

  const trimmedSearchQuery = searchQuery.trim().toLowerCase();
  const isSearching = !strUtil.isEmpty(trimmedSearchQuery);

  const sortedParameterDefinitions = naturalSortByKey(parameterDefinitions, 'name');
  const parameterDefinitionsMatchingQuery = isSearching
    ? sortedParameterDefinitions.filter((pd) => pd.name.toLowerCase().includes(trimmedSearchQuery))
    : sortedParameterDefinitions;
  const filteredParameterDefinitions = parameterDefinitionsMatchingQuery.filter((pd) =>
    pd.archiveData.archived
      ? selectedArchivePurposes.includes(pd.archiveData.purpose!)
      : selectedArchivePurposes.includes(NOT_ARCHIVED_PURPOSE_STRING)
  );

  return {
    filteredParameterDefinitions,
    searchQuery,
    setSearchQuery,
    selectedArchivePurposes,
    selectArchivePurposes,
  };
}
